import { PropsWithChildren } from 'react'
import { useBfnStore } from '@/store/useBfnStore'
import { checkAbruftokenExpired } from '@/features/befehlsnachrichten/utils/abruftoken'
import { useShallow } from 'zustand/react/shallow'
import BefehlsnachrichtUpdater from './BefehlsnachrichtUpdater'
import { useBefehlsnachrichtenCleanup } from '@/features/befehlsnachrichten/hooks/useBefehlsnachrichtenCleanup'

export default function BefehlsnachrichtenProvider({
  children
}: Readonly<PropsWithChildren>) {
  const [data, pendingTokens] = useBfnStore(
    useShallow((state) => [state.data, state.pendingTokens])
  )

  useBefehlsnachrichtenCleanup()

  const bfnToUpdate = Object.entries(data).filter(([, { abruftoken }]) => {
    // no updating if abruftoken is expired
    return !checkAbruftokenExpired(abruftoken)
  })

  return (
    <>
      {pendingTokens.map((abruftoken) => (
        <BefehlsnachrichtUpdater
          key={`${abruftoken.typ}${abruftoken.abruftoken}`}
          abruftoken={abruftoken}
        />
      ))}
      {bfnToUpdate.map(([id, { abruftoken }]) => (
        <BefehlsnachrichtUpdater key={id} abruftoken={abruftoken} />
      ))}
      {children}
    </>
  )
}
